import * as types from './mutation-types'

export const exit = ({ commit }) => {
    commit(types.SET_STATE, { newState: null });
}



// WEBPACK FOOTER //
// ./src/store/actions.js